<template>
    <div class="info-box" :style="{ backgroundColor: colorfondo }">
        <span :title="tituloasegurado" class="info-box-icon bg-danger elevation-1 pers"
            style="width:50px;height:50px;margin-top:5px"><i class="fas fa-house-user"></i></span>
        <div class="info-box-content">
            <span v-if="asegurado.nombre && asegurado.nombre.length < 50" :title="asegurado.nombre"
                class="info-box-text" style="font-size:1rem">{{ asegurado.nombre }}</span>
            <span v-if="asegurado.nombre && asegurado.nombre.length >= 50" :title="asegurado.nombre"
                class="info-box-text" style="font-size:1rem">{{ asegurado.nombre.substr(0, 46) }}...</span>

            <span class="info-box-text telefonoa" style="font-size:1rem">
                <i v-if="asegurado.telefono1" class="fas fa-phone-alt" style="color:black;cursor:default"></i>
                <a style="font-size:1rem" target="_blank" :href="telefono1">&nbsp;&nbsp;{{ asegurado.telefono1 }} &nbsp;
                </a>
                <a style="font-size:1rem" target="_blank" v-if="asegurado.telefono2" :href="telefono2">&nbsp;&nbsp;{{
                    asegurado.telefono2}}&nbsp;</a>
                <a style="font-size:1rem" target="_blank" v-if="asegurado.telefono3" :href="telefono3">&nbsp;&nbsp;{{
                    asegurado.telefono3 }}</a>
            </span>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';

  

export default ({
    props: ['id','servicio','asegurado'],
    data() {
        return {
            telefono1:'',
            telefono2: '',
            telefono3:'',
            colorfondo:'',
            tituloasegurado:'Asegurado',
        }
    },
    setup() {     
    },
    methods: {
        async sacarenlace() {
        /*GET /servicios/:id_servicio/llamada?telefono=telefono*/
            const api = new PwgsApi();
            if(this.asegurado.telefono1){
                this.telefono1 = await api.get('servicios/' + this.$props.id + '/llamada?telefono=' + this.asegurado.telefono1);
            }
            if (this.asegurado.telefono2) {
                this.telefono2 = await api.get('servicios/' + this.$props.id + '/llamada?telefono=' + this.asegurado.telefono2);
            }
            if (this.asegurado.telefono3) {
                this.telefono3 = await api.get('servicios/' + this.$props.id + '/llamada?telefono=' + this.asegurado.telefono3);
            }
        }
    },
    mounted() {

    },
    watch:{
        asegurado() {
            this.sacarenlace();

            if(this.asegurado.conflictivo==1){
                this.colorfondo='#ffc107!important';
                this.tituloasegurado='Asegurado conflictivo';
            }else{
                this.colorfondo='';
                this.tituloasegurado='Asegurado';
            }
        },
        servicio() {
        }
    }


})


</script>
<style>
.telf{
    color: #fff !important;
    border-color: #fff !important;
}
.pers{
    background:#6f42c1 !important
}
.telefonoa {
    color:blue;
    cursor:pointer;
}
</style>